export const Wz5FormValidator = {
    data() {
        return {
            v_error: false,
            v_is_valid: false,
            v_validation_error: null,
        }
    },
    methods: {
        validateForm: function (data) {
            switch (data.current_form) {
                case 'J':
                    return this.v_validateDecision(data.decision);
            }
        },
        v_validateDecision: function (decision) {
            /** FAULT complaint type */
            if (typeof (decision) === 'undefined' || decision === null || decision === '') {
                this.v_is_valid = false;
                this.v_error = true;
                this.v_validation_error = this.$t('validations.memory_decision_empty');
                return false;
            } else {
                this.v_is_valid = true;
                this.v_error = false;
                this.v_validation_error = null;
                return true;
            }
        },
    }
}